import type { TypeProductListTemplateDetailed, TypeStandardTemplateDetailed } from 'types/autogen/contentful';
import TemplateComponentRenderer from '../shared/TemplateComponentRenderer';

export default function ({
    entries
}: {
    entries:
        | TypeProductListTemplateDetailed['fields']['contentOverPLP']
        | TypeProductListTemplateDetailed['fields']['contentUnderPLP']
        | TypeStandardTemplateDetailed['fields']['content'];
}) {
    if (!entries || entries.length === 0) return null;

    return entries.map((x) => <TemplateComponentRenderer key={x.sys.id} {...x} />);
}
